<div class="billing-counter">
    <div class="billing-counter-container">
        <div class="billing-counter-title">
            {{ 'billing.this-month' | translate }}
        </div>
        <div class="billing-counter-content">
            <span>{{ 'billing.new-transport' | translate }} : </span>{{ transportCounter?.currentMonthCounter | number
            :'0.0' :'fr'}} ({{transportCounter?.currentMonthQuantity | number :'0.0' :'fr'}} {{ 'label.tonnes' | translate }})
        </div>
    </div>
    <div class="billing-counter-container">
        <div class="billing-counter-title">
            {{ 'billing.previous-month' | translate }}
        </div>
        <div class="billing-counter-content">
            <span>{{ 'billing.new-transport' | translate }} : </span>{{ transportCounter?.previousMonthCounter | number
            :'0.0' :'fr'}} ({{transportCounter?.previousMonthQuantity | number :'0.0' :'fr'}} {{ 'label.tonnes' | translate }})
        </div>
    </div>
</div>
<mat-tab-group #tabGroup>
    <mat-tab>
        <ng-template mat-tab-label>
            <mat-icon>update</mat-icon>
            <span>{{ 'label.billing-todo' | translate }}</span>
        </ng-template>
        <div class="billing-todo-main-container">
            <app-month-select style="width: 300px;" (billingMonthSelectEmit)="refreshGrid($event)"
                [listBillingToDo]="listBillingToDo"></app-month-select>
            <app-billing-todo style="width: 100%;" (refreshEmit)="refreshMonth($event)"
                [billingMonthSelect]="billingMonthSelect"></app-billing-todo>
        </div>
    </mat-tab>
    <mat-tab>
        <ng-template mat-tab-label>
            <mat-icon>assignment_turned_in</mat-icon>
            <!-- <span>{{ 'label.billing-done' | translate }}</span> -->
            <span>{{ 'label.billing-historic' | translate }}</span>
        </ng-template>
        <app-billing-done #billingDoneGrid></app-billing-done>
    </mat-tab>
    <mat-tab>
        <ng-template mat-tab-label>
            <mat-icon>credit_card</mat-icon>
            <span>{{ 'label.billing-free' | translate }}</span>
        </ng-template>
        <div class="free-billing-main-container">
            <app-billing-free style="width: 100%;"></app-billing-free>
        </div>
    </mat-tab>

</mat-tab-group>